import React, { useState, useEffect } from 'react';

import { getval2Token, setVal2Token } from '../../../Login/Auth';
import { SingleText } from '../../Res/BaseInput';
import { getCaseStatus, getCaseStatusString } from '../../../../item/ItemRecruitmentContractorStatus';
import { ReqRecruitmentContractorCaseInfo, VIEW_CASESTATUS2, VIEW_CANCEL_TO_RESERVE, VIEW_INVALID, JOB_STATUS_ONBOARD } from '../../../../item/ItemRecruitmentContractor';
import { ContentBox } from '../ContentBox';
import { SingleBigButton } from '../../Res/BaseButton';
import { ReviseInvalid } from './ReviseInvalid';
import { ReviseCancel2Reserve } from './ReviseCancel2Reserve';
import Swal from 'sweetalert2';
import moment from 'moment';

export function ReviseSOPCaseStatus2({ id, setIsLoading, isEdit = false }) {
  const [tokenId, setTokenId] = useState("")
  const [recruitmentContractorStatusItem, setRecruitmentContractorStatusItem] = useState(null)
  const [item, setItem] = useState(null)

  const [vw_status, set_vw_status] = useState(<></>)
  const [content, setContent] = useState(<></>)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var item = getval2Token("ReviseSOPCaseStatus2", id)
      console.log(item)
      var obj = getval2Token("recruitmentContractorStatusItem", id)
      console.log(obj)
      setRecruitmentContractorStatusItem(obj)
      setTokenId(id)
      setItem(item)
      var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
      mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
      set_vw_status(
        <>
          <SingleText title={"目前的 案件狀態"} val={item.caseContractorName + " " + getCaseStatusString(item, mReqRecruitmentContractorCaseInfo)} />
          <SingleText title={"當時的 預定上工日"} val={moment(mReqRecruitmentContractorCaseInfo.caseReserveDate).format('YYYY/MM/DD')} />
          <SingleText title={"當時的 案件管轄者"} val={item.caseOwnerName} />
        </>
      )
      //setContent(<ReviseView item={item} caseContractorName={caseContractorName} caseStatus={caseStatus} statusDate={statusDate} caseOwnerName={caseOwnerName} action={change} />)
    }
  }, [id])

  useEffect(() => {
    if (item !== null && tokenId !== null) {
      var view = getval2Token("view", tokenId)
      // console.log(view||VIEW_CASESTATUS1)
      change(view)
    }
  }, [item, tokenId])

  function change(val) {
    // console.log(item)
    switch (val) {
      case VIEW_CANCEL_TO_RESERVE:
        console.log(recruitmentContractorStatusItem)
        if(recruitmentContractorStatusItem.contractorJobStatus +""=== JOB_STATUS_ONBOARD){
          Swal.fire({
            type: 'error',
            title: '外派員工已“上工”',
          })
          return
        }
        setContent(<ReviseCancel2Reserve item={item} action={change} vw_status={vw_status} setIsLoading={setIsLoading} />)
        break;
      case VIEW_INVALID:
        setContent(<ReviseInvalid item={item} action={change} view={VIEW_CASESTATUS2} vw_status={vw_status}  setIsLoading={setIsLoading}/>)
        break;
      default:
        setContent(<ReviseView item={item} action={change} vw_status={vw_status} />)
        break;
    }
    setVal2Token('view', val, tokenId)
  }

  return (
    <>{content}</>
  )

}

function ReviseView({ item, action, vw_status }) {
  const [mItem, setItem] = useState({})
  const [caseStatus, setCaseStatus] = useState("")
  const [statusDate, setStatusDeta] = useState("")
  const [caseContractorName, setCaseContractorName] = useState("")
  const [caseOwnerName, setCaseOwnerName] = useState("")
  useEffect(() => {
    if (item !== undefined && item !== mItem) {
      console.log(item)
      setItem(item)
      setCaseOwnerName(item.caseOwnerName)
      setCaseContractorName(item.caseContractorName)
      var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
      mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
      console.log(mReqRecruitmentContractorCaseInfo)
      var cs = getCaseStatus(item, mReqRecruitmentContractorCaseInfo)
      setCaseStatus(cs.status)
      setStatusDeta(cs.statusDeta)
    }
  }, [item])


  function toReserve() {
    action(VIEW_CANCEL_TO_RESERVE)
  }
  function toCaseStatusInvalid() {
    action(VIEW_INVALID)
  }

  var superTitle = "請選擇要進行哪一種修正方式"
  var title = ""
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          {vw_status}
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"從“未報到” 改為 “預定中”"} action={toReserve} />

          <div className="col-md-9">
            <p className="col-md-12">
              注意：如果該外派員工已經“上工了”，系統會禁止此修正作業！</p>
            <p className="col-md-12">
              提示：這代表，已由別的“派遣案件”，報到上工了。所以也不需要修正此案件了</p>
          </div>
        </div>
      </div>

      <div className="hr-line-dashed"></div>

      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"作廢此 ”派遣案件“"} action={toCaseStatusInvalid} />


          <div className="col-md-9">
            <p className="col-md-12">
              注意：作廢後，無法復原！請三思而後行。案件作廢後，“招募績效”就不會統計此案了。</p>
          </div>
        </div >
      </div >
    </>

  return (
    <>
      <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} hasDrawer={false} />
    </>
  )
}

